import { palette } from '../palette';

const MuiDataGrid = {
  styleOverrides: {
   root: ({theme} : any) => ({
      '& .MuiDataGrid-columnHeader': {
        '&:focus-within': {
          outline: 'none',
        },
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: '1rem',
        color: theme.palette.text.primary,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '0.9rem',
      },
      '& .MuiDataGrid-iconSeparator':{
        color: 'transparent',
      },
    }),
  },
};

export default MuiDataGrid;
